import momentJalaali from "moment-jalali";
import Loader from "react-loader-spinner";
import { useDispatch } from "react-redux";
import { Fragment, useEffect, useState } from "react";
import icons8 from "../content/images/icons8-go-back-24.png";
import backWhite from "../content/images/icons8-go-back-White.png";
import { useHistory, useLocation, useParams } from "react-router-dom";
import "../Css/Stimulsoft/stimulsoft.viewer.office2013.lightgrayblue.css";
import "../Css/Stimulsoft/stimulsoft.designer.office2013.lightgrayblue.css";
import { savePrintReport, loadPrintReport, loadPrintDataSource_get, loadPrintDataSource_post, setErrorDialog } from "../store/api/CommonFunctions";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";


const PrintViewer = () => {

    const history = useHistory();
    const [loaded, setLoaded] = useState(true);
    const dispatch = useDispatch();
    const location = useLocation();
    const dataUrlInfo = location.state;
    const [pending, setPending] = useState(false);
    const { reportName, designMode } = useParams();
    const company = JSON.parse(localStorage.getItem("Company"));
    const report = new window.Stimulsoft.Report.StiReport();
    report.info.zoom = 0.9;


    function setReportData(jsonData) {
        let varNow = new window.Stimulsoft.Report.Dictionary.StiVariable();
        varNow.name = "CurrentDate";
        varNow.alias = "تاریخ امروز";
        varNow.Type = window.Stimulsoft.System.StimulsoftType;
        varNow.requestFromUser = false;
        varNow.value = momentJalaali().format('jYYYY/jM/jD');
        report.dictionary.variables.add(varNow);
        let varAddress = new window.Stimulsoft.Report.Dictionary.StiVariable();
        varAddress.name = "CompanyAddress";
        varAddress.alias = "آدرس شرکت";
        varAddress.Type = window.Stimulsoft.System.Type;
        varAddress.requestFromUser = false;
        varAddress.value = company?.CompanyAddress;
        report.dictionary.variables.add(varAddress);
        let varName = new window.Stimulsoft.Report.Dictionary.StiVariable();
        varName.name = "CompanyName";
        varName.alias = "نام شرکت";
        varName.Type = window.Stimulsoft.System.StimulsoftType;
        varName.requestFromUser = false;
        varName.value = company?.CompanyName;
        report.dictionary.variables.add(varName);
        var varTel = new window.Stimulsoft.Report.Dictionary.StiVariable();
        varTel.name = "CompanyPhone";
        varTel.alias = "تلفن شرکت";
        varTel.Type = window.Stimulsoft.System.StimulsoftType;
        varTel.requestFromUser = false;
        varTel.value = company?.Phone;
        report.dictionary.variables.add(varTel);

        const dataSet = new window.Stimulsoft.System.Data.DataSet("ds" + reportName);
        if (!window.Stimulsoft.Report.Dictionary.StiFunctions.functions.keys.includes("ModifyDigits")) {
            const fnModifyDigits = (value) => {
                if (value) {
                    return value.replaceAll("٤", "۴").replaceAll("٥", "۵").replaceAll("٦", "۶")
                }
                else {
                    return "";
                }
            }

            window.Stimulsoft.Report.Dictionary.StiFunctions.addFunction("Strings", "ModifyDigits", "ModifyDigits", "تبدیل اعداد عربی به فارسی", "", String, "فارسی شده اعداد عربی", [String], ["value"], ["Descriptions"], fnModifyDigits)

        } 
        dataSet.readJson(JSON.stringify(jsonData));
        report.regData("ds" + reportName, "ds" + reportName, dataSet);
        if (dataUrlInfo.fetchBody) {
            const dataSetFilters = new window.Stimulsoft.System.Data.DataSet("dsFilters");
            dataSetFilters.readJson(dataUrlInfo.fetchBody);
            if (dataSetFilters.tables.list[0]) {
                dataSetFilters.tables.list[0]._tableName = "tblFilters";
            }
            report.regData("dsFilters", "dsFilters", dataSetFilters);
        }
        report.dictionary.synchronize();
        setPending(false);
        report.reportAlias = reportName;
        if (!designMode || designMode.toLowerCase() === "false") {
            const viewOptions = new window.Stimulsoft.Viewer.StiViewerOptions();
            viewOptions.appearance.fullScreenMode = true;
            viewOptions.appearance.scrollbarsMode = true;
            viewOptions.toolbar.showViewModeButton = true;
            viewOptions.toolbar.printDestination = window.Stimulsoft.Viewer.StiPrintDestination.Direct;
            const viewer = new window.Stimulsoft.Viewer.StiViewer(viewOptions, "StiViewer", false);
            viewer.report = report;
            viewer.renderHtml("printDesigner");
            viewer.onPrintReport = function (event) {
                console.log(event);

            }
            var userButton = viewer.jsObject.SmallButton("userButton", "بازگشت", "emptyImage");
            userButton.style["font-family"] = "Vazir";
            userButton.style["color"] = "blue";
            userButton.image.src = icons8;
            userButton.action = function () { history.goBack() }

            var toolbarTable = viewer.jsObject.controls.toolbar.firstChild.firstChild;
            var buttonsTable = toolbarTable.rows[0].firstChild.firstChild;
            var userButtonCell = buttonsTable.rows[0].insertCell(0);
            userButtonCell.className = "stiJsViewerClearAllStyles";
            userButtonCell.appendChild(userButton);
        }
        else if (designMode.toLowerCase() === "true") {
            const options = new window.Stimulsoft.Designer.StiDesignerOptions();
            options.appearance.fullScreenMode = true;
            options.appearance.htmlRenderMode = window.Stimulsoft.Report.Export.StiHtmlExportMode.Div;
            const designer = new window.Stimulsoft.Designer.StiDesigner(options, "Designer", false);
            designer.onSaveReport = function (e) {
                const jsonStr = e.report.saveToJsonString();
                savePrintReport(reportName, jsonStr);
            }
            designer.onSaveAsReport = (e) => {
                e.fileName = "Letter_" + e.fileName;
                e.report.reportName = e.fileName;
                e.report.reportAlias = e.fileName;
                const jsonStr = e.report.saveToJsonString();
                savePrintReport(e.fileName, jsonStr);
            }
            designer.report = report;
            designer.renderHtml("printDesigner");
            designer.jsObject.options.images["ImageBack"] = backWhite;
            var toolBarRow = designer.jsObject.options.toolBar.firstChild.tr[0];
            var customButton = designer.jsObject.StatusPanelButton("btnBack", "بازگشت", "ImageBack", null, null, 30, 30);
            customButton.action = function () { history.goBack() }
            customButton.style["font-family"] = "Vazir";
            customButton.style["color"] = "white";
            var buttonCell = document.createElement("td");
            buttonCell.className = "stiDesignerToolButtonCell";
            buttonCell.appendChild(customButton);
            toolBarRow.insertBefore(buttonCell, toolBarRow.childNodes[0]);

        }
    }
    function print(res) {
        if (dataUrlInfo.dataUrl) {
            if (res.Message) {
                setLoaded(false);
                setErrorDialog(dispatch, res.Message, "چاپ اطلاعات");
                return;
            }
            setPending(true);
            report.load(res);
            if (dataUrlInfo.method === "get") {
                dispatch(loadPrintDataSource_get(dataUrlInfo.dataUrl, setReportData, dataUrlInfo.serverUrl));
            }
            else if (dataUrlInfo.method === "post") {
                dispatch(loadPrintDataSource_post(dataUrlInfo.dataUrl, dataUrlInfo.fetchBody, setReportData, dataUrlInfo.serverUrl));
            }
        }
        else{
            if (res?.Message) {
                setLoaded(false);
                setErrorDialog(dispatch, res.Message, "چاپ اطلاعات");
                return;
            }
            report.load(res);
            setReportData(dataUrlInfo.jsonObject??{});
        }
    }
    useEffect(() => {
        document.body.classList = "notMain";
        loadPrintReport(reportName, designMode.toLowerCase() === "true", print, dataUrlInfo.serverUrl);

    }, [])
    return (
        <Modal show={true} size="xl" onHide={() => { }}>
            <Modal.Header style={{ padding: loaded ? "1px" : "10px", direction: "ltr" }} className="headerStyle">
                {!loaded && <span> <FontAwesomeIcon icon={faTimes} size="lg" onClick={() => history.goBack()} /> </span>}
            </Modal.Header>
            <Modal.Body style={{ minHeight: "95vh" }} className="bodyStyle">
                <div id="printDesigner" style={{ direction: "ltr" }}>
                    {pending &&
                        <Fragment>
                            <div>&nbsp;</div>
                            <div style={{ textAlign: "center" }}>
                                <Loader type="BallTriangle" color="#bb1370" height={40} width={40} />
                            </div>
                        </Fragment>
                    }
                </div>
            </Modal.Body>
        </Modal>
    )
}
export default PrintViewer;